module.exports = __webpack_public_path__ + "img/V1.546dfee8.jpg";